const CONVERSATION_SECTION = 'conversations';
const MARKETING_SECTION = 'marketing';

const TEMPLATE_SECTIONS = [
    CONVERSATION_SECTION,
    MARKETING_SECTION,
];

export {
    TEMPLATE_SECTIONS,
    CONVERSATION_SECTION,
    MARKETING_SECTION,
};
